import { computed, type ComputedRef } from 'vue'
import { Color, ColorSemantic } from '@previo/codebooks'
import { type PMaxLines, type PWhiteSpace } from '../types'

export type TypographyOptions = {
  color?: null | Color | ColorSemantic
  bold?: boolean
  italic?: boolean
  underline?: boolean
  strike?: boolean
  maxLines?: null | PMaxLines
  ellipsis?: boolean
  whiteSpace?: PWhiteSpace
}

export function useTypographyClasses(options: TypographyOptions): ComputedRef<string[]> {
  return computed<string[]>(() => {
    const classes = []

    if (options.color) {
      classes.push(`text-${options.color}`)
    }

    if (options.bold) {
      classes.push('p-text-bold')
    }

    if (options.italic) {
      classes.push('p-text-italic')
    }

    if (options.underline) {
      classes.push('p-text-underline')
    }

    if (options.strike) {
      classes.push('p-text-strike')
    }

    if (options.ellipsis) {
      classes.push('ellipsis')
    } else {
      if (options.maxLines) {
        classes.push(`p-text-max-lines-${options.maxLines}`)
      }

      if (options.whiteSpace) {
        classes.push(`p-text-ws-${options.whiteSpace}`)
      }
    }

    return classes
  })
}
